import { render, staticRenderFns } from "./Moto.vue?vue&type=template&id=790435cc&"
import script from "./Moto.vue?vue&type=script&lang=js&"
export * from "./Moto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports